import { Center, Flex, Tooltip } from '@chakra-ui/react';
import { FaCheckCircle } from 'react-icons/fa';
import { IoIosCloseCircle } from 'react-icons/io';
import { KText } from '@/ui-library/components/text';
export const AutoSaveLoadingIndicator = ({ isSaved , containerProps = {} }) => {
  return (
    <Center justifyContent="flex-end" pr="20px" gap="18px" {...containerProps}>
      {isSaved === 'isLoading' ? (
        <KText fontWeight="semiBold" color="#777777">
          Saving...
        </KText>
      ) : isSaved === 'success' ? (
        <Flex gap="6px" alignItems={'center'}>
          <FaCheckCircle
            style={{
              color: '#5FBB3F',
              width: '14px',
              height: '14px',
            }}
          />
          <KText fontWeight="semiBold" color="secondary-900">
            Auto-saved
          </KText>
        </Flex>
      ) : isSaved === 'error' ? (
        <Tooltip
          hasArrow
          label="Unable to auto-save. Save your work elsewhere to avoid losing it."
        >
          <Flex gap="6px" alignItems={'center'}>
            <IoIosCloseCircle
              style={{
                color: '#F95D2D',
                width: '14px',
                height: '14px',
              }}
            />
            <KText fontWeight="semiBold" color="#0E0C0F">
              Auto-save failed
            </KText>
          </Flex>
        </Tooltip>
      ) : null}
    </Center>
  );
};
